import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Asset from './Asset';

export default class MaxWidthCard extends Component {
  render() {
    const {
      anchor,
      images,
      align,
      header,
      color,
      copy,
      links,
    } = this.props;

    return (
      <section id={anchor || undefined} className="max-width-card">
        <div className="max-width-card-container">
          {images && images.length > 0 && (
            <Asset asset={images[0]} />
          )}
          <div className={classNames('max-width-card-copy', align?.toLowerCase(), color?.toLowerCase())}>
            <div className="max-width-card-copy-headers">
              <h3>{header}</h3>
              {copy
                && (
                  <h4>
                    {copy}
                  </h4>
                )}
            </div>
            {links && links.length > 0 && (
              <Link
                className={`label ${links[0].textColor || ''}`}
                to={links[0].destinationPage.url}
              >{links[0].text}
              </Link>
            )}
          </div>
        </div>
      </section>
    );
  }
}
